// 侧边栏组件--带有回到顶部的功能
<template>
  <div class="side_tool_wrap hidden-xs-only">
    <div class="tool_item_container">
      <div class="side_1">
        <div class="icon_box">
          <img src="@/assets/img/navigate/chat.png" alt="联系我们"/>
        </div>
        <i></i>
        <div class="text_box">
          联系我们
        </div>
      </div>
      <div class="side_2 side">
        <div class="icon_box">
          <img src="@/assets/img/navigate/phone.png" alt="电话">
        </div>
        <div class="text_box">
          400-8775178
        </div>
      </div>
      <div class="side_3 side">
        <div class="icon_box">
          <img src="../assets/img/navigate/email.png" alt="邮箱">
        </div>
        <div class="text_box">
          rqzhineng@163.com
        </div>
      </div>
      <div class="side_4">
        <div class="top_box">
          <div class="icon_box">
            <img src="../assets/img/navigate/chat.png" alt="邮箱">
          </div>
          <div class="text_box">
            关注我们
          </div>
        </div>
        <img src="../assets/img/navigate/wxQR.jpg" alt="" class="QR_box">
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped lang="scss">
.side_tool_wrap {
  position: fixed;
  right: 0;
  top: 30%;
  //transform: translateY(-50%);
  z-index: 999999;
  .tool_item_container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .side_1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 150px;
    background: #222;
    text-align: center;
    transition: all 0.5s;
    &:hover {
      background: #0555b6;
      cursor: pointer;
    }
    i {
      width: 1px;
      height: 20px;
      margin: 10px auto;
      background: #ffffff;
    }
    .text_box {
      margin: 0 auto;
      color: #fff;
      font-size: 14px;
      writing-mode: vertical-lr;
    }
  }
  .side_2 {
    &:hover {
      width: 190px;
      cursor: pointer;
    }
    .icon_box {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      background: #0555b6;
    }
  }
  .side_3 {
    &:hover {
      width: 190px;
      cursor: pointer;
    }
    .icon_box {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      background: #0555b6;
    }
  }
  .side_4 {
    display: flex;
    flex-direction: column;
    height: 50px;
    width: 50px;
    margin-top: 1px;
    background: #ffffff;
    overflow: hidden;
    transition: all 0.5s;
    &:hover {
      width: 140px;
      height: 163px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5); /* 边框阴影 */
      cursor: pointer;
    }
    .top_box {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      .icon_box {
        flex-shrink: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50px;
        height: 50px;
        background: #0555b6;
      }
      .text_box {
        flex-shrink: 0;
        width: 90px;
        background: #232323;
        text-align: center;
        line-height: 50px;
        font-size: 14px;
        color: #ffffff;
        overflow: hidden;
      }
    }
    .QR_box {
      width: 112px;
      height: 111px;
      margin: auto;
      background: #ffffff;
    }
  }
  .side_5 {
    margin-top: 2px;
    &:hover {
      cursor: pointer;
    }
    .icon_box {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      background: #0555b6;
    }
  }
  .side {
    display: flex;
    flex-direction: row;
    height: 50px;
    width: 50px;
    margin-top: 1px;
    background: #222222;
    overflow: hidden;
    transition: all 0.5s;
  }
  .side .text_box {
    flex-shrink: 0;
    width: 140px;
    background: #232323;
    text-align: center;
    line-height: 50px;
    font-size: 14px;
    color: #ffffff;
    overflow: hidden;
    transition: all 1s;
  }
}
</style>
